import { render } from "./Subject_list.vue?vue&type=template&id=7a04a0ee"
import script from "./Subject_list.vue?vue&type=script&lang=js"
export * from "./Subject_list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__